import type { PageInstanceSummary } from "@octopusdeploy/portal-routes";
import { PageInstanceSummaryProvider } from "@octopusdeploy/portal-routes";
import React, { useCallback, useEffect, useState } from "react";
import { currentPageContext } from "~/openTelemetry/context/currentPageContext";
import type { GlobalPageDetails } from "~/routing/UpdateGlobalPageDetailsContext";
import { UpdateGlobalPageDetailsProvider } from "~/routing/UpdateGlobalPageDetailsContext";
import type { VerticalNavigationPageArea } from "~/routing/VerticalNavigationPageAreaContext";
import { VerticalNavigationPageAreaProvider } from "~/routing/VerticalNavigationPageAreaContext";
import { setPageForOperationTimer } from "~/utils/OperationTimer/timeOperation";
interface GlobalPageProviderProps {
    children: React.ReactNode;
}
export function GlobalPageProvider({ children }: GlobalPageProviderProps) {
    const [currentPage, setCurrentPage] = useState<PageInstanceSummary | undefined>(undefined);
    const [verticalNavigationPageArea, setVerticalNavigationPageArea] = useState<VerticalNavigationPageArea | undefined>();
    const updateGlobalPageDetailsCallback = useCallback(({ pageId, pageName, pageArea, pageInstanceId, routeParams, routeTemplate, owner, verticalNavigationPageArea }: GlobalPageDetails) => {
        setCurrentPage({ Id: pageId, Name: pageName, Area: pageArea, instanceId: pageInstanceId, routeParams, routeTemplate, owner });
        setVerticalNavigationPageArea(verticalNavigationPageArea);
    }, []);
    useEffect(() => {
        if (currentPage !== undefined) {
            currentPageContext.setPage(currentPage);
            setPageForOperationTimer(currentPage);
        }
    }, [currentPage]);
    return (<PageInstanceSummaryProvider page={currentPage}>
            <VerticalNavigationPageAreaProvider value={verticalNavigationPageArea}>
                <UpdateGlobalPageDetailsProvider value={updateGlobalPageDetailsCallback}>{children}</UpdateGlobalPageDetailsProvider>
            </VerticalNavigationPageAreaProvider>
        </PageInstanceSummaryProvider>);
}
